import { HttpErrorResponse } from '@angular/common/http';
import { Action } from '@ngrx/store';
import { PageUserAddressListResponse } from '@services/back-office/model/pageUserAddressListResponse';
import { UserAddressEditRequest } from '@services/back-office/model/userAddressEditRequest';
import { UserAddressListResponse } from '@services/back-office/model/userAddressListResponse';
import { UserAddressSearchRequest } from '@services/back-office/model/userAddressSearchRequest';
import { PaginationModel } from '@shared/models/pagination.model';

export enum RequestsActionTypes {
  LoadRequests = '[Requests] Load Requests',
  LoadRequestsSuccess = '[Requests] Load Requests Success',
  LoadRequestsFailure = '[Requests] Load Requests Failure',
  AddRequestFromStomp = '[Requests] Add Request From Stomp',
  SetInProgressRequests = '[Requests] SetInProgress Requests',
  SetInProgressRequestsSuccess = '[Requests] Set In Progress Requests Success',
  SetInProgressRequestsFailure = '[Requests] Set In Progress Requests Failure',
  DeleteRequests = '[Requests] Delete Requests',
  DeleteRequestsSuccess = '[Requests] Delete Requests Success',
  DeleteRequestsFailure = '[Requests] Delete Requests Failure',
  ChangePage = '[Requests] Change Page',
  SetInitialPagination = '[Requests] Set Initial Pagination',
  SetFilter = '[Requests] Set Filter',
  ClearFilter = '[Requests] Clear Filter',
  SetInitialState = '[Requests] Set Initial State',
}

/** Load Requests */
export class LoadRequests implements Action {
  readonly type = RequestsActionTypes.LoadRequests;
  constructor(public payload?: {dontShowLoading: boolean}) {}
}

export class LoadRequestsSuccess implements Action {
  readonly type = RequestsActionTypes.LoadRequestsSuccess;
  constructor(public payload: PageUserAddressListResponse) { }
}

export class LoadRequestsFailure implements Action {
  readonly type = RequestsActionTypes.LoadRequestsFailure;
  constructor(public payload: HttpErrorResponse) { }
}

/** Add Request From Stomp */
export class AddRequestFromStomp implements Action {
  readonly type = RequestsActionTypes.AddRequestFromStomp;
}

/** Set In Progress Request */
export class SetInProgressRequests implements Action {
  readonly type = RequestsActionTypes.SetInProgressRequests;
  constructor(public payload: {request: UserAddressEditRequest, userAddressId: string}) {}
}

export class SetInProgressRequestsSuccess implements Action {
  readonly type = RequestsActionTypes.SetInProgressRequestsSuccess;
  constructor(public payload: UserAddressListResponse) { }
}

export class SetInProgressRequestsFailure implements Action {
  readonly type = RequestsActionTypes.SetInProgressRequestsFailure;
  constructor(public payload: HttpErrorResponse) { }
}

/** Delete Requests */
export class DeleteRequests implements Action {
  readonly type = RequestsActionTypes.DeleteRequests;
  constructor(public payload: string) {}
}

export class DeleteRequestsSuccess implements Action {
  readonly type = RequestsActionTypes.DeleteRequestsSuccess;
  constructor(public payload: void) { }
}

export class DeleteRequestsFailure implements Action {
  readonly type = RequestsActionTypes.DeleteRequestsFailure;
  constructor(public payload: HttpErrorResponse) { }
}

/** Change Page */
export class ChangePage implements Action {
  readonly type = RequestsActionTypes.ChangePage;
  constructor(public payload: PaginationModel) { }
}

/** Set Initial Pagination */
export class SetInitialPagination implements Action {
  readonly type = RequestsActionTypes.SetInitialPagination;
}

/** Set Filter */
export class SetFilter implements Action {
  readonly type = RequestsActionTypes.SetFilter;
  constructor(public payload: UserAddressSearchRequest) { }
}

/** Clear Filter */
export class ClearFilter implements Action {
  readonly type = RequestsActionTypes.ClearFilter;
}

/** Set Initial State */
export class SetInitialState implements Action {
  readonly type = RequestsActionTypes.SetInitialState;
}

export type RequestsActions =
  | LoadRequests
  | LoadRequestsSuccess
  | LoadRequestsFailure
  | AddRequestFromStomp
  | SetInProgressRequests
  | SetInProgressRequestsSuccess
  | SetInProgressRequestsFailure
  | DeleteRequests
  | DeleteRequestsSuccess
  | DeleteRequestsFailure
  | ChangePage
  | SetInitialPagination
  | SetFilter
  | ClearFilter
  | SetInitialState
  ;

